<template>
  <div id="profile" class="body">
    <Top />

    <div role="main" class="main">
      <section class="page-header page-header-classic page-header-sm">
        <div class="container">
          <div class="row">
            <div class="col-md-8 order-2 order-md-1 align-self-center p-static">
              <h1 data-title-border>会社概要</h1>
            </div>
            <div class="col-md-4 order-1 order-md-2 align-self-center">
              <ul class="breadcrumb d-block text-md-right">
                <li><router-link to="/index">Home</router-link></li>
                <li class="active">会社案内</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section class="company-layout">
        <CompanyNav active-key="profile" />

        <div class="page-card">
          <p class="page-kicker">Company Profile</p>
          <h2>InnoSource株式会社</h2>
          <table class="table">
            <tbody>
              <tr>
                <th class="w-25" scope="row">社名</th>
                <td>InnoSource株式会社</td>
              </tr>
              <tr>
                <th scope="row">住所・電話</th>
                <td>
                  <router-link to="/access">事務所</router-link><br>
                  〒850-0035<br>
                  長崎県長崎市元船町9-18 2階<br>
                  Email: info@innosource.co.jp
                </td>
              </tr>
              <tr>
                <th scope="row">代表者</th>
                <td>代表取締役 顧 楽諾</td>
              </tr>
              <tr>
                <th scope="row">設立</th>
                <td>令和5年7月7日</td>
              </tr>
              <tr>
                <th scope="row">資本金</th>
                <td>資本金1250万円</td>
              </tr>
              <tr>
                <th scope="row">取引銀行</th>
                <td></td>
              </tr>
              <tr>
                <th scope="row">従業員数</th>
                <td>10名</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>

    <Foot />
  </div>
</template>

<script>
import Top from '@/components/top';
import Foot from '@/components/foot';
import CompanyNav from '@/components/companyNav';

export default {
  name: 'profile',
  components: {
    Top,
    Foot,
    CompanyNav,
  },
};
</script>
